<ng-container *ngIf="currentState$ | async as state">
  <button
    *ngIf="!state.isOpen"
    class="text-white font-bold py-2 p-[14px] rounded-[10px] flex items-center justify-center w-[100%] h-[48px] mt-[23px] mb-[15px]"
    [ngClass]="{
      'bg-[#E76B3F] hover:bg-[#36be71]': state.isApproved,
      'bg-[#E76B3F] hover:bg-[#203D54]': !state.isApproved
    }"
    (click)="openSendForApproval()"
  >
    <span>{{
      state.isApproved ? "Sent For Approval" : "Send For Approval"
    }}</span>
  </button>

  <div *ngIf="state.isOpen" class="section-color">
    <div>
      <div
        class="bg-[#AAD4F5] w-[100%] h-[56px] flex justify-start items-center text-gray-700 rounded-t-[10px]"
      >
        <span class="pl-[29px] font-roboto text-[24px] font-semibold">
          Send Approval
        </span>
      </div>

      <div class="flex ml-[29px] mt-[26px]">
        <div
          class="block text-[18px] font-semibold text-gray-700 mt-[10px] mb-[10px] mr-[78px] w-[73px]"
        >
          Send to
        </div>
        <div class="autocomplete-container relative" #dropdownContainer>
          <div *ngIf="state.isLoading" class="absolute right-3 top-3">
            <div
              class="animate-spin rounded-full h-5 w-5 border-b-2 border-[#2368A2]"
            ></div>
          </div>

          <div *ngIf="state.error" class="text-red-500 text-sm mb-2">
            {{ state.error }}
          </div>

          <!-- TODO: why is this not working. it was working before -->
          <div (clickOutside)="onClickOutside()">
            <input
              #inputFieldUser
              [formControl]="userControl"
              placeholder="Select Users"
              (click)="toggleDropdown($event)"
              class="rounded-[10px] border border-[#1a4971] shadow-md bg-inherit h-[44px] pl-[15px] w-[335px]"
              [class.pr-10]="state.isLoading"
            />
            <div
              *ngIf="state.showDropdown"
              class="dropdown absolute z-10 w-full mt-1 bg-white rounded-md shadow-lg max-h-[200px] overflow-y-auto"
            >
              <div *ngIf="state.filteredUsers.length > 0; else noResults">
                <div
                  *ngFor="let user of state.filteredUsers"
                  (mousedown)="onSelectionChange(user)"
                  class="p-2 hover:bg-gray-100 cursor-pointer"
                >
                  {{ user.name }}
                </div>
              </div>
              <ng-template #noResults>
                <div class="p-2 text-gray-500">No users found</div>
              </ng-template>
            </div>
          </div>

          <div class="selected-users mb-[10px]">
            <div *ngFor="let user of state.selectedUsers" class="flex mt-2">
              <span
                class="inline-flex items-center justify-between min-w-[150px] h-[44px] bg-[#D8EEFF] border border-[rgba(35,104,162,0.2)] rounded-[10px] px-3 py-1 w-[200px]"
              >
                {{ user.name }}
                <button
                  type="button"
                  (click)="remove(user)"
                  class="w-[22px] h-[22px] bg-black rounded-full flex items-center justify-center text-white -mr-[6px]"
                >
                  x
                </button>
              </span>
              <span
                class="w-[200px] flex items-center ml-[15px] text-[#037847]"
              >
                Send for Approval
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex ml-[29px] mt-[26px]">
        <h2
          class="text-xl !font-bold !text-[16px] !mt-[-20px] text-[#203d54] mb-4 !mr-[77px]"
        >
          Add Note
        </h2>
        <app-rich-textEditor
          class="w-[83%]"
          (contentChange)="addNote($event)"
          [resetEditor]="resetRichTextEditor"
        ></app-rich-textEditor>
      </div>

      <div class="flex justify-end mb-[25px] mt-[26px] mr-[94px]">
        <button
          type="button"
          class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center mr-[12px]"
          (click)="closeSendForApproval()"
        >
          <span>Cancel</span>
        </button>
        <button
          [disabled]="state.isLoading"
          class="bg-[#1A4971] hover:bg-blue-500 text-white font-bold py-2 px-4 rounded inline-flex items-center"
          (click)="sendApprovalRequest()"
        >
          <span>Save</span>
        </button>
      </div>
    </div>
  </div>
</ng-container>
